export default __webpack_public_path__ + "static/media/Director-giving-speech-portrait.10caff07.jpeg";